<ng-container *ngIf="permConfig.isEditAllowed">
    <div class="container-fluid">
        <div class="container-fluid">
          <div class="row d-flex align-items-center">
            <!-- Air Waybill Title -->
            <div class="col-12 col-md-6 d-flex align-items-center">
              <div class="me-4">
                <app-page-title title="Airway Bill"></app-page-title>
              </div>

                <!-- Focus Mode Section -->
                <div class="col-md-3 center-items-custom col-lg-3 text-center mb-2 mb-md-0 me-3">
                    <div class="form-check form-switch form-switch-sm ms-2" style="cursor: pointer;">
                        <label for="focusModeCheck" class="form-check-label d-flex align-items-center">
                            <input #focusModeCheckBox type="checkbox" id="focusModeCheck" class="form-check-input me-2"
                              (change)="toggleFocusMode($event)">Focus Mode
                        </label>
                    </div>
                </div>
                <!-- Copy to New Section -->
                <!-- <div class="col-md-4 col-lg-4 d-flex align-items-center mb-2 mb-md-0">
                  <div class="form-check form-switch form-switch-sm d-flex align-items-center gap-2 flex-nowrap">
                      <input type="checkbox" id="SwitchCheckSizemd" class="form-check-input"
                          (change)="onChangeCopyToNew($event.target.checked);" [disabled]="isLocked">
                      <label for="SwitchCheckSizemd" class="form-check-label mb-0">Copy to new</label>
                  </div>
              </div> -->
            </div>
        
            <!-- Balances and History Section -->
            <div class="row">
              <div class="col-md-12">
                  <div class="card" style="margin: 5px 0px 20px 0px">
                      <div class="card-body card-summary" style="padding-top: 5px; padding-bottom: 5px">
                          <ul class="list-inline mb-0 d-flex flex-wrap align-items-center justify-content-end w-100">
                              <li class="list-inline-item me-3" *ngIf="tabPermission.charges">
                                  <label class="form-label custom-label me-2">
                                      <span class="icon-circle-bg me-1">
                                          <i class="fas fa-user"></i>
                                          <i class="fas fa-coins"></i>
                                      </span>
                                      <b>Total Customer Charges: </b>
                                  </label>{{totalCustomerCharges}}
                              </li>
                              <li class="list-inline-item me-3" *ngIf="tabPermission.forwardinginfo && !isAccessTypeCustomer">
                                  <label class="form-label custom-label me-2">
                                      <span class="icon-circle-bg me-1">
                                          <i class="fas fa-coins"></i>
                                          <i class="fas fa-arrow-right"></i>
                                      </span>
                                      <b>Total Forwarding Charges: </b>
                                  </label>{{totalForwardingCharges}}
                              </li>
                              <li class="list-inline-item mx-1 btn btn-outline-light position-relative p-0 avatar-xs" 
                                  ngbTooltip="History" placement="top" container="body">
                                  <span class="avatar-title bg-transparent text-reset" (click)="onHistoryClick()">
                                      <i class="bx bx-history action-group custom-width font-size-22"></i>
                                  </span>
                              </li>
                          </ul>
                      </div>
                  </div>
              </div>
            </div>
        </div>
        
        </div>
        
        <div class="row" *ngIf="isLocked">
            <div class="alert alert-danger alert-dismissible fade show" role="alert">
                <i class="mdi mdi-alert-outline me-2"></i>
                <span>Entry <b>locked</b> due to <b>{{lockReason}}</b></span>
            </div>
        </div>
        <div class="fab-container">
            <span class="fab-wrapper" (click)="showConfiguration()">
                <i class="bx bxs-cog  action-group custom-width font-size-18"></i>
            </span>
        </div>
    </div>
 
    <div class="overlay" *ngIf="isModalOpen" (click)="hide()">
        <div class="modal-content" (click)="$event.stopPropagation()">
            <div class="modal-header">
                <div class="rightbar-title px-3 py-4">
                    <a href="javascript:void(0);" class="right-bar-toggle float-end" (click)="hide();">
                        <i class="mdi mdi-close noti-icon"></i>
                    </a>
                    <h5 class="modal-title m-0">AWB Configuration</h5>
                </div>
            </div>
            <div class="row" style="overflow: auto;background-color: #8080800d;">
                <form [formGroup]="awbConfigForm">
                <div class="tab-content" id="v-pills-tabContent">
                    <div class="tab-pane fade show active" id="v-pills-shipping" role="tabpanel"
                    aria-labelledby="v-pills-shipping-tab">
                    <div class="row">
                        
                        <ng-container formArrayName="configDetails">
                            <div class="event-type" *ngFor="let detail of configDetails.controls; let i = index" [formGroupName]="i">
                                <div class="form-check d-flex align-items-start flex-column text-wrap">
                                    <div class="d-flex align-items-center">
                                    <input 
                                    [id]="sanitizeId(detail.get('name').value)" style="cursor: pointer"
                                    class="form-check-input" 
                                    type="checkbox" 
                                    [formControl]="detail.get('ischecked')">
                                    
                                    <label 
                                    [for]="sanitizeId(detail.get('name').value)" style="cursor: pointer"
                                    class="ms-2 mt-1 d-flex align-items-center">
                                    <i class="fas" [ngClass]="detail.get('icon').value" style="font-size: 17px; margin-right: 10px;"></i>
                                    <b>{{ detail.get('name').value }}</b>
                                    </label>
                                    
                                    </div>
                                    <label style="margin-left: 5px; margin-top: -8px;"> Allowed when wanting same {{
                                    detail.get('name').value }} for all AWB forms.
                                    </label>
                                </div>
                            </div>
                            </ng-container>
                                
                    </div>
                    </div>
                </div>
                </form>
            </div>
            <div class="row mb-4 mt-1">
                <div class="col-12">
                <div class="button-items">
                    <button type="button" class="btn btn-primary btn-md" (click)="configData()">Save</button>
                </div>
                </div>
            </div>
        </div>
    </div>
    
    <form [formGroup]="awbForm">
      <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-md-1 mb-2">
                <div class="d-flex align-items-center">
                  <label for="referenceNo" class="form-label mb-0">Reference No.</label>
                  <input type="checkbox" id="referenceNo" class="ms-1" [checked]="getCheckedStatus('referenceNo')"  (change)="toggleFieldCheck('referenceNo', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                <input #referenceNo type="text" class="form-control form-control-sm" id="referenceNo" formControlName="txtReferenceNo" maxlength="30"
                  (keydown.enter)="useEnterKey && focusNextField('referenceNo')" (change)="bindPickupById($event.target.value)">
              </div>

              <div class="col-md-2 mb-2">
                <div class="d-flex align-items-center">
                  <label for="awbNo" class="form-label">AWB No.</label>
                  <input type="checkbox" id="awbNo" class="ms-1" [checked]="getCheckedStatus('awbNo')"  (change)="toggleFieldCheck('awbNo', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <input #awbNo type="text" maxlength="30" class="form-control form-control-sm" id="awbNo" 
                    formControlName="txtAwbNo" 
                    (keydown.enter)="useEnterKey && awbForm.get('txtAwbNo').valid ? focusNextField('awbNo') : awbForm.get('txtAwbNo').markAsTouched()"
                    [ngClass]="{'is-invalid':(isFormSubmitted || awbForm.get('txtAwbNo').touched) && awbForm.get('txtAwbNo').errors}" />
                  <div *ngIf="(isFormSubmitted || awbForm.get('txtAwbNo').touched) && awbForm.get('txtAwbNo').errors"
                    class="invalid-feedback">
                    <span *ngIf="awbForm.get('txtAwbNo').errors.maxlength">Awb No max length is
                      30 characters</span>
                    <span *ngIf="awbForm.get('txtAwbNo').errors.pattern">Invalid Pattern. Only accept alphanumeric values.</span>
                  </div>
              </div>

            <div class="col-md-3 mb-2">
              <div class="d-flex align-items-center">
                <label for="customer" class="form-label">Customer</label>
                <input type="checkbox" id="customer" class="ms-1" [checked]="getCheckedStatus('customer')"  (change)="toggleFieldCheck('customer', $event.target.checked)"  [hidden]="focusCheckHide">
              </div>
                <ng-select #customer id="customer"  placeholder="Select" [items]="customerList" [appendTo]="'body'" [openOnEnter]="false"
                  formControlName="ddlCustomer" bindLabel="name" [bindValue]="'id'"
                  (change)="bindCustomerShipperInfo();bindProformaCsbDetails('customer');bindCustomerKYC();" 
                    (keydown.enter)="useEnterKey && awbForm.get('ddlCustomer').valid ? focusNextField('customer') : awbForm.get('ddlCustomer').markAsTouched()"
                  class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                  [ngClass]="{'is-invalid':(isFormSubmitted || awbForm.get('ddlCustomer').touched) && awbForm.get('ddlCustomer').errors}">
                </ng-select>
            </div>

              <div class="col-md-3 mb-2">
                <div class="d-flex align-items-center">
                  <label for="company" class="form-label">Company <span class="mandatory">*</span></label>
                  <input type="checkbox" id="company" class="ms-1" [checked]="getCheckedStatus('company')"  (change)="toggleFieldCheck('company', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <ng-select #company id="company" placeholder="Select" [items]="companyList" [appendTo]="'body'" [openOnEnter]="false"
                    formControlName="ddlCompanies" bindLabel="name" [bindValue]="'id'" 
                    (keydown.enter)="useEnterKey && awbForm.get('ddlCompanies').valid ? focusNextField('company') : awbForm.get('ddlCompanies').markAsTouched()"
                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                    [ngClass]="{ 'is-invalid':(isFormSubmitted || awbForm.get('ddlCompanies').touched) && awbForm.get('ddlCompanies').errors }">
                  </ng-select>
                  <div *ngIf="
                    (isFormSubmitted || awbForm.get('ddlCompanies').touched) && awbForm.get('ddlCompanies').errors"
                    class="invalid-feedback">
                    <span *ngIf="awbForm.get('ddlCompanies').errors.required">Company is
                      required</span>
                  </div>
                </div>

              <div class="col-md-2 mb-2">
                <div class="d-flex align-items-center">
                  <label for="bookDateTime" class="form-label">Book Date</label><span class="mandatory">*</span>
                  <input type="checkbox" id="bookDate1Time" class="ms-1" [checked]="getCheckedStatus('bookDateTime')"  (change)="toggleFieldCheck('bookDate1Time', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <input #bookDateTime type="datetime-local" class="form-control form-control-sm" id="bookDateTime"
                    formControlName="txtDateTime"
                    [min]="minBookingDate" max="3000-12-31T23:59"
                    (keydown.enter)="useEnterKey && awbForm.get('txtDateTime').valid ? focusNextField('bookDateTime') : awbForm.get('txtDateTime').markAsTouched()"
                    [ngClass]="{'is-invalid': (isFormSubmitted || awbForm.get('txtDateTime')?.touched) && awbForm.get('txtDateTime').errors}" />
                  <div
                    *ngIf="(isFormSubmitted || awbForm.get('txtDateTime')?.touched) && awbForm.get('txtDateTime').errors"
                    class="invalid-feedback">
                    <span *ngIf="awbForm.get('txtDateTime').errors.minDate">Date must be valid</span>
                    <span *ngIf="awbForm.get('txtDateTime').errors.required">Book Date is required</span>
                  </div>
                </div>

              <div class="col-md-1 mb-2">
                <div class="d-flex align-items-center">
                  <label for="paymentType" class="form-label">Payment Type</label>
                  <input type="checkbox" id="paymentType" class="ms-1" [checked]="getCheckedStatus('paymentType')"  (change)="toggleFieldCheck('paymentType', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <ng-select #paymentType id="paymentType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" [items]="paymentTypeList"
                    formControlName="ddlPaymentType" [clearable]="false"
                    (keydown.enter)="useEnterKey && awbForm.get('ddlPaymentType').valid ? focusNextField('paymentType') : awbForm.get('ddlPaymentType').markAsTouched()"
                    [ngClass]="{'is-invalid': (isFormSubmitted || awbForm.get('ddlPaymentType')?.touched) && awbForm.get('ddlPaymentType').errors}">
                  </ng-select>
                </div>
            </div>

            <div class="row">
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="product" class="form-label">Product <span class="mandatory">*</span></label>
                  <ng-select #product id="product" [items]="productOptions" bindLabel="code" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                    formControlName="ddlProduct" placeholder="Select"
                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                    (change)="getAWBCharges(category.CUSTOMER)"
                    [ngClass]="{'is-invalid':(isFormSubmitted || awbForm.get('ddlProduct').touched) && awbForm.get('ddlProduct').errors }" 
                    (keydown.enter)="useEnterKey && awbForm.get('ddlProduct').valid ? focusNextField('product') : awbForm.get('ddlProduct').markAsTouched()">
                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                      <span>{{ item.name }}</span>
                    </ng-template>
                  </ng-select>
                  <span *ngIf="selectedProduct?.shipmenttype" style="font-size:11px;" class="badge bg-primary mt-1">Shipment type :
                    {{selectedProduct?.shipmenttype}}</span>
                  <div
                    *ngIf="(isFormSubmitted || awbForm.get('ddlProduct').touched) && awbForm.get('ddlProduct').errors"
                    class="invalid-feedback">
                    <span *ngIf="awbForm.get('ddlProduct').errors.required">Product is Required</span>
                    </div>
                  </div>
                </div>

              <div class="col-md-2">
                <div class="mb-2">
                  <label for="vendor" class="form-label">Vendor <span class="mandatory">*</span></label>
                  <ng-select #vendor id="vendor" [items]="vendorOptions" bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false"
                    formControlName="ddlVendor" placeholder="Select"
                    (change)="getAllVendorServices();bindSpecialServices(); bindDeliveryVendor()" 
                    (keydown.enter)="useEnterKey && awbForm.get('ddlVendor').valid ? focusNextField('vendor') : awbForm.get('ddlVendor').markAsTouched()"
                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                    [ngClass]="{'is-invalid': (isFormSubmitted || awbForm.get('ddlVendor').touched) && awbForm.get('ddlVendor').errors }">
                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                      <span>{{ item.name }}</span>
                    </ng-template>
                  </ng-select>
                  <div
                  *ngIf=" (isFormSubmitted || awbForm.get('ddlVendor').touched) && awbForm.get('ddlVendor').errors "
                  class="invalid-feedback">
                  <span *ngIf="awbForm.get('ddlVendor').errors.required">Vendor is Required</span>
                  </div>
                </div>
                </div>

              <div class="col-md-2 mb-2">
                <div class="d-flex align-items-center">
                  <label for="service" class="form-label">Service <span class="mandatory">*</span></label>
                  <input type="checkbox" id="service" class="ms-1" [checked]="getCheckedStatus('service')"  (change)="toggleFieldCheck('service', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <ng-select #service id="service" [items]="serviceOptions" bindLabel="servicename" [bindValue]="'id'" placeholder="Select"
                    formControlName="ddlService" [appendTo]="'body'" [openOnEnter]="false"
                    (change)="vendorServiceChange($event);getAWBCharges(category.CUSTOMER);getServiceConfig();"
                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                    [ngClass]="{ 'is-invalid':(isFormSubmitted || awbForm.get('ddlService').touched) && awbForm.get('ddlService').errors}"
                    (keydown.enter)="useEnterKey && awbForm.get('ddlService').valid ? ChargeTypes.focus() : awbForm.get('ddlService').markAsTouched()">
                    <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                      <span>{{ item.servicename }}</span>
                  </ng-template>
                  </ng-select>
                  <div
                    *ngIf="(isFormSubmitted || awbForm.get('ddlService').touched) && awbForm.get('ddlService').errors "
                    class="invalid-feedback">
                    <span *ngIf="awbForm.get('ddlService').errors.required">Service is
                      Required</span>
                  </div>
                </div>


              <div class="col-md-3 mb-2">
                <div class="d-flex align-items-center">
                  <label for="ChargeTypes" class="form-label">Charge Types</label>
                  <input type="checkbox" id="ChargeTypes" class="ms-1" [checked]="getCheckedStatus('ChargeTypes')"  (change)="toggleFieldCheck('ChargeTypes', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <ng-select #ChargeTypes id="ChargeTypes" [items]="selectChargeTypes" [multiple]="true" [appendTo]="'body'" [openOnEnter]="false"
                    class="ng-select ng-select-multiple ng-select-searchable ng-select-clearable ng-select-bottom"
                    formControlName="ddlChargeType" placeholder="Select" (change)="getAWBCharges(category.CUSTOMER)"
                    (keydown.enter)="useEnterKey && awbForm.get('ddlChargeType').valid ? 
                        utilities.closeCurrentAndFocusNext(ChargeTypes, (awbForm.get('txtShipmentValue').disabled? currencyRef:  shipmentValue)): awbForm.get('ddlChargeType').markAsTouched()">
                    <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
                      <div class="ng-value" *ngFor="let item of items | slice:0:2">
                          <span class="ng-value-label">{{item}}</span>
                          <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
                      </div>
                      <div class="ng-value" *ngIf="items.length > 2">
                          <span class="ng-value-label">{{items.length - 2}} more...</span>
                      </div>
                    </ng-template>
                  </ng-select>
              </div>

              <div class="col-md-2 mb-2">
                <div class="d-flex align-items-center">
                  <label for="shipmentValue" class="form-label">Shipment Value <span *ngIf="awbForm.get('txtShipmentValue').errors?.required" class="mandatory">*</span></label>
                  <input type="checkbox" id="shipmentValue" class="ms-1" [checked]="getCheckedStatus('shipmentValue')"  (change)="toggleFieldCheck('shipmentValue', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <input #shipmentValue type="number" class="form-control form-control-sm" id="shipmentValue" appLimitDigits [length]="12"
                    (keydown)="onKeyDown($event)" formControlName="txtShipmentValue"
                    [ngClass]="{'is-invalid':(isFormSubmitted ||awbForm.get('txtShipmentValue').touched) && awbForm.get('txtShipmentValue').errors}"
                    (keydown.enter)="useEnterKey && awbForm.get('txtShipmentValue').valid ? (isShipperCustomerBinded? focusConsignee(): appShipperAddress.focusFirstField()) : awbForm.get('txtShipmentValue').markAsTouched()" />
                  <div
                    *ngIf="(isFormSubmitted || awbForm.get('txtShipmentValue').touched) && awbForm.get('txtShipmentValue').errors"
                    class="invalid-feedback">
                    <span *ngIf="awbForm.get('txtShipmentValue').errors.pattern">max 12 digit and at most three decimal places</span>
                    <span *ngIf="awbForm.get('txtShipmentValue').errors?.required">Shipment value is required</span>
                  </div>
              </div>
              <div class="col-md-1 mb-2">
                <div class="d-flex align-items-center">
                  <label for="currency" class="form-label">Currency</label>
                  <input type="checkbox" id="currency" class="ms-1" [checked]="awbFocusCheckMap?.currency" [hidden]="focusCheckHide">
                </div>
                <ng-select #currencyRef [items]="currencyList" bindLabel="currencycode" [bindValue]="'currencycode'" 
                    [appendTo]="'body'" [openOnEnter]="false" placeholder="Select" formControlName="ddlCurrency" [clearable]="false" 
                    (keyup.enter)="useEnterKey && (isShipperCustomerBinded? focusConsignee(): appShipperAddress.focusFirstField())">
                </ng-select>
            </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 d-flex flex-grow-1">
        <div class="card flex-grow-1">
          <div class="card-header bg-transparent border-bottom text-uppercase">
            SHIPPER
          </div>
          <div class="card-body">

          <div class="row">
            <app-address #appShipperAddress formGroupName="shipperlocationdetails" [formSubmitted]="isFormSubmitted"
            [listType]="'origin'" [address]="shipperLocationInfo" 
            [countryList] = "CountryList"
            [conditionalCountryList]="conditionalCountryList" 
            (addressBookListEmit)="getAddressbookList($event)" (byLocationChange)="isShipperCustomerBinded = false"
            (getAddress)="getOriginLocation($event)" (getSelectedAddressKycInfo)="bindAddressKycInfo($event, 'Shipper')" 
            (focusEmit)="focusNextField('appShipperAddress')" [focusCheckHide]="focusCheckHide" (emitAddressCheck)="updateAddressCheck($event)">
            </app-address>
          </div>

            <div class="row">
              <div class="col-md-3 mb-2">
                <div class="d-flex align-items-center">
                  <label for="shipperiecioeno" class="form-label">IOSS/EORI No.</label>
                  <input type="checkbox" id="shipperiecioeno" class="ms-1" [checked]="getCheckedStatus('shipperiecioeno')"  (change)="toggleFieldCheck('shipperiecioeno', $event.target.checked)"  [hidden]="focusCheckHide">
                </div>
                  <input #shipperiecioeno type="text" maxlength="30" class="form-control form-control-sm" id="shipperiecioeno"
                    formControlName="txtShipperIecIoeNo" 
                    (keydown.enter)="useEnterKey && focusNextField('shipperiecioeno')"/>
              </div>
            </div>

          <div class="row">
            <div class="col-md-6">
              <div class="mb-2">
                <label for="shipperdoc" class="form-label">Document Type</label>
                <ng-select #shipperdoc id="shipperdoc" [items]="documentOptions" bindLabel="name" [bindValue]="'name'" 
                [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlShipperDocumentType" placeholder="Select"
                (change)="documentTypeValidation('shipperdoc', true)" 
                (keydown.enter)="useEnterKey && awbForm.get('ddlShipperDocumentType').valid ? shipperDocumentNo.focus() : awbForm.get('ddlShipperDocumentType').markAsTouched()"></ng-select>
              </div>
            </div>
            <div class="col-md-6">
              <div class="mb-2">
                <label for="shipperDocumentNo" class="form-label">Document No.</label>
                <input #shipperDocumentNo type="text" class="form-control form-control-sm" id="shipperDocumentNo" (change)="validateGSTINStateSelection($event.target.value, 'shipper')"
                formControlName="txtShipperDocumentNo" 
                (keydown.enter)="useEnterKey && awbForm.get('txtShipperDocumentNo').valid ? appConsigneeAddress.focusFirstField() : awbForm.get('txtShipperDocumentNo').markAsTouched()" [maxlength]="docCharacterLimit"
                  [ngClass]="{'is-invalid': (isFormSubmitted || awbForm.get('txtShipperDocumentNo').touched) && awbForm.get('txtShipperDocumentNo').errors}">
                <div
                *ngIf="(isFormSubmitted || awbForm.get('txtShipperDocumentNo').touched) && awbForm.get('txtShipperDocumentNo').errors"
                class="invalid-feedback">
                <span *ngIf="awbForm.get('txtShipperDocumentNo').errors.required">Document No. is required</span>
                <span *ngIf="awbForm.get('txtShipperDocumentNo').errors.pattern">{{shipperDocValidationMsg}}</span>
              </div>
            </div>
            </div>
            </div>
          </div>
        </div>
      </div>

        <div class="col-md-6 d-flex flex-grow-1">
          <div class="card flex-grow-1">
            <div class="card-header bg-transparent border-bottom text-uppercase">
              CONSIGNEE
            </div>
            <div class="card-body">
              <div class="row">
                <app-address #appConsigneeAddress formGroupName="consigneelocationdetails" [formSubmitted]="isFormSubmitted"
                    [listType]="'destination'" [address]="consigneeLocationInfo" [productFilteredCountryList]="productFilteredCountryList"
                    [conditionalCountryList]="conditionalCountryList" (addressBookListEmit)="getAddressbookList($event)"
                    (getAddress)="getDestinationLocation($event)" (getSelectedAddressKycInfo)="bindAddressKycInfo($event, 'Consignee')"
                    [focusConsigneeName]="focusConsigneeName" [countryList] = "CountryList"
                    (focusEmit)="focusNextField('appConsigneeAddress')" [focusCheckHide]="focusCheckHide" (emitAddressCheck)="updateAddressCheck($event)">
                  </app-address>
              </div>

              <div class="row">
                <div class="col-md-3 mb-2">
                  <div class="d-flex align-items-center">
                    <label for="consigneeiecioeno" class="form-label">IOSS/EORI No.</label>
                    <input type="checkbox" id="consigneeiecioeno" class="ms-1" [checked]="getCheckedStatus('consigneeiecioeno')"  (change)="toggleFieldCheck('consigneeiecioeno', $event.target.checked)"  [hidden]="focusCheckHide">
                  </div>
                    <input type="text" maxlength="30" class="form-control form-control-sm" id="consigneeiecioeno" #consigneeiecioeno
                      formControlName="txtConsigneeIecIoeNo" 
                      (keydown.enter)="useEnterKey && focusNextField('consigneeiecioeno')"/>
                </div>
              </div>

            <div class="row">
              <div class="col-md-6">
                <div class="mb-2">
                  <label for="documenttype" class="form-label">Document Type</label>
                  <ng-select #consigneedoc id="consigneedoc" [items]="documentOptions" bindLabel="name" [bindValue]="'name'" 
                  (change)="documentTypeValidation('consigneedoc', true)" [appendTo]="'body'" [openOnEnter]="false"
                  formControlName="ddlConsigneeDocumentType" placeholder="Select" 
                  (keydown.enter)="useEnterKey && awbForm.get('ddlConsigneeDocumentType').valid ? consigneeDocNo.focus() : awbForm.get('ddlConsigneeDocumentType').markAsTouched()"></ng-select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-2">
                  <label for="consigneeDocNo" class="form-label">Document No.</label>
                  <input #consigneeDocNo type="text" class="form-control form-control-sm" id="consigneeDocNo" (change)="validateGSTINStateSelection($event.target.value, 'consignee')"
                  formControlName="txtConsigneeDocumentNo" [maxlength]="docCharacterLimit" 
                  (keydown.enter)="useEnterKey && (awbForm.get('txtConsigneeDocumentNo').valid? focusFirstActualWeight(): awbForm.get('txtConsigneeDocumentNo').markAsTouched())"
                  [ngClass]="{'is-invalid': (isFormSubmitted || awbForm.get('txtConsigneeDocumentNo').touched) && awbForm.get('txtConsigneeDocumentNo').errors}">
                  <div *ngIf="(isFormSubmitted || awbForm.get('txtConsigneeDocumentNo').touched) && awbForm.get('txtConsigneeDocumentNo').errors"
                  class="invalid-feedback">
                  <span *ngIf="awbForm.get('txtConsigneeDocumentNo').errors.required">Document No. is required.</span>
                  <span *ngIf="awbForm.get('txtConsigneeDocumentNo').errors.pattern">{{consigneeDocValidationMsg}}</span>
                </div>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <ul ngbNav #justifiednav="ngbNav" [(activeId)]="activeTabId" class="nav-pills bg-light rounded nav">
              <li #weightDimentionsTabRef [ngbNavItem]="1">
                <a ngbNavLink (click)="focusTabField(measurementUnit)">
                  <span class="d-block d-sm-none"><i class="fas fa-home"></i></span>
                  <span class="d-none d-sm-block">Weight & Dimensions</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="WeightDimensions"></ng-template>
                </ng-template>
              </li>
              <li #proformaTabRef [ngbNavItem]="2" *ngIf="tabPermission.proforma">
                <a ngbNavLink (click)="focusTabField(csbtype)">
                  <span class="d-block d-sm-none"><i class="fas fa-file-invoice"></i></span>
                  <span class="d-none d-sm-block">Proforma</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="ProformaContent"></ng-template>
                </ng-template>
              </li>
              <li #chargesTabRef [ngbNavItem]="3" *ngIf="tabPermission.charges">
                <a ngbNavLink (click)="forwardingInfoTab = false; focusTabField(appSharedCustomercharge)">
                  <span class="d-block d-sm-none"><i class="fas fa-file-invoice-dollar"></i></span>
                  <span class="d-none d-sm-block">Charges</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="ChargesContent"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="4" *ngIf="tabPermission.shipmentinfo">
                <a ngbNavLink (click)="focusTabField(fieldExecutive)">
                  <span class="d-block d-sm-none"><i class="fas fa-box"></i></span>
                  <span class="d-none d-sm-block">Shipment Info</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="ShipmentContent"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="5" *ngIf="tabPermission.specialservices && showSpecialServices">
                <a ngbNavLink (click)="focusTabField(btnfuelradio1)">
                  <span class="d-block d-sm-none"><i class="fas fa-cog"></i></span>
                  <span class="d-none d-sm-block">Special Services</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="SpecialServicesContent"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="6" *ngIf="!isAccessTypeCustomer && tabPermission.forwardinginfo">
                <a ngbNavLink (click)="forwardingInfoTab = true; focusTabField(deliveryawb)">
                  <span class="d-block d-sm-none"><i class="fas fa-cube"></i></span>
                  <span class="d-none d-sm-block">Forwarding Info</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="ForwardingContent"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="7" *ngIf="tabPermission.kyc">
                <a ngbNavLink (click)="focusTabField(kycDocumentType)">
                  <span class="d-block d-sm-none"><i class="fas fa-user-check"></i></span>
                  <span class="d-none d-sm-block">KYC</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="KYCContent"></ng-template>
                </ng-template>
              </li>
              <li [ngbNavItem]="8" *ngIf="tabPermission.receipts">
                <a ngbNavLink (click)="focusTabField(amountReceived)">
                  <span class="d-block d-sm-none"><i class="fas fa-receipt"></i></span>
                  <span class="d-none d-sm-block">Receipts</span>
                </a>
                <ng-template ngbNavContent>
                  <ng-template [ngTemplateOutlet]="ReceiptsContent"></ng-template>
                </ng-template>
              </li>
            </ul>

          <div [ngbNavOutlet]="justifiednav"></div>

          <ng-template #WeightDimensions>
            <div class="row d-flex">
              <div class="col-md-2 mb-2">
                <div class="mb-2">
                  <label for="measurementUnit" class="form-label">Measurement Unit</label>
                  <ng-select #measurementUnit id="measurementUnit" bindLabel="name" [items]="unitList" placeholder="Select"
                    [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlMeasurementUnit" (change)="volumetricDetails('',true)"
                    [ngClass]="{ 'is-invalid': (isFormSubmitted || awbForm.get('ddlMeasurementUnit')?.touched) && awbForm.get('ddlMeasurementUnit').errors }"
                    (keydown.enter)="useEnterKey && focusFirstActualWeight()">
                  </ng-select>
                  <div
                    *ngIf="(isFormSubmitted || awbForm.get('ddlMeasurementUnit')?.touched) && awbForm.get('ddlMeasurementUnit').errors"
                    class="invalid-feedback">
                    <span *ngIf="awbForm.get('ddlMeasurementUnit').errors.required">Unit is
                      required</span>
                  </div>
                </div>
              </div>

              <div class="col-md-1 mb-2">
                <div class="mb-2">
                  <label for="division" class="form-label">Division</label>
                  <input #division type="text" id="division" class="form-control form-control-sm" formControlName="txtDivision"
                    (keydown.enter)="useEnterKey && importPieces.focus()"/>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="card">
                <div class="card-header bg-transparent border-bottom text-uppercase"> PIECES DETAILS</div>
                <div class="card-body">
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div> <small for="importPieces"><i class="mdi mdi-information">Note: Only .xlsx and .xls files under 1 MB are allowed.</i></small></div>
                        <div class="row d-flex align-items-center">
                          <div class="col-sm-9 col-md-8 col-xs-12 d-flex">
                            <div class="input-group flex-grow-1">
                              <input #importPieces id="importPieces" type="file" class="form-control form-control-sm" accept=".xlsx"
                                (change)="onChangeFileSelect($event, 'AWBPieces')" formControlName="txtFile"
                                (keydown.enter)="useEnterKey && uploadPiecesBtn.focus()">
                              <button #uploadPiecesBtn type="button" class="btn btn-primary btn-sm d-flex align-items-center mt-0" (click)="uploadPiecesFile()"
                                (keydown.enter)="uploadPiecesFile()" (keydown.enter)="useEnterKey && unit.focus()">
                                <i class="bx bx-upload font-size-15 me-1"></i>Upload
                              </button>
                            </div>
                          </div>
                          <div class="col-sm-2 col-md-4 d-flex justify-content-start">
                            <button type="button" class="btn btn-primary btn-sm px-2" (click)="downloadFile()">
                              <i class="bx bx-download font-size-15 me-1"></i>Download
                            </button>
                          </div>
                        
                          <!-- Progress Bar should only be under the input group -->
                          <div class="col-md-8 col-xs-12" *ngIf="showProgressBar">
                            <div class="progress mt-2">
                              <div class="progress-bar progress-bar-striped" role="progressbar" [style.width.%]="progress"
                                [attr.aria-valuenow]="progress" aria-valuemin="0" aria-valuemax="100">
                                {{progress}}%
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <form [formGroup]="piecesForm">
                      <div class="row mt-2 responsive-section">
                        <!-- Total Pieces Section -->
                        <div class="col-lg-1 col-md-2 col-sm-1 col-6 mb-2">
                          <label for="totalpieces" class="form-label">Total Pieces <span class="mandatory">*</span></label>
                          <input type="number" formControlName="totalpieces" class="form-control form-control-sm"
                            id="totalpieces" min="1" max="30" (keydown)="totalPiecesValidate($event)"
                            [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalpieces')?.touched) && piecesForm.get('totalpieces').errors }" />
                          <div *ngIf="(isFormSubmitted || piecesForm.get('totalpieces')?.touched) && piecesForm.get('totalpieces').errors" class="invalid-feedback">
                            <span *ngIf="piecesForm.get('totalpieces').errors.required">Total Pieces are required</span>
                          </div>
                        </div>

                        <!-- Weight Section -->
                        <div class="col-lg-5 col-md-6 col-sm-9 col-12 mb-2">
                          <label for="weight" class="form-label">Weights</label>
                          <div class="input-group">
                            <span class="input-group-text group-label-sm">Actual <span class="mandatory">*</span></span>
                            <input type="number" class="form-control form-control-sm" id="actualweight"
                              formControlName="totalactualweight" (change)="getAWBCharges(category.CUSTOMER)"
                              (keydown)="piecesValidate($event)"
                              [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalactualweight').touched) && piecesForm.get('totalactualweight').errors }" />

                            <span class="input-group-text group-label-sm">Volumetric</span>
                            <input type="number" class="form-control form-control-sm" id="volumetricweight"
                              formControlName="totalvolumetricweight" (keydown)="piecesValidate($event)"
                              [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalvolumetricweight').touched) && piecesForm.get('totalvolumetricweight').errors }" />

                            <span class="input-group-text group-label-sm">Chargeable</span>
                            <input type="number" class="form-control form-control-sm" id="chargeweight"
                              formControlName="totalchargeableweight" (keydown)="piecesValidate($event)"
                              [ngClass]="{ 'is-invalid': (isFormSubmitted || piecesForm.get('totalchargeableweight').touched) && piecesForm.get('totalchargeableweight').errors }" />

                            <span class="input-group-text group-label-sm">Unit</span>
                            <ng-select #unit [items]="unitOptions" bindLabel="name" [clearable]="false" [bindValue]="'name'"
                              [appendTo]="'body'" [openOnEnter]="false" formControlName="actualweightunit" placeholder="Select"
                              class="ng-select" (keydown.enter)="useEnterKey && focusFirstActualWeight()">
                            </ng-select>
                          </div>
                        </div>

                        <!-- Compare Rates Button -->
                        <div class="col-lg-3 col-md-3 col-sm-4 col-6 text-center d-flex align-items-end">
                          <label class="form-label d-none"></label>
                          <button type="button" (click)="searchRates();" class="btn btn-primary btn-sm d-block mb-2">
                            Compare Rates
                          </button>
                        </div>

                        <!-- Add New Row Button -->
                        <div
                          class="col-lg-3 col-md-3 col-sm-4 col-6 text-center mt-sm-0 d-flex align-items-end justify-content-end">
                          <button type="button" (click)="addNewContainerCustom();"
                            class="btn btn-primary btn-sm d-block mb-2">
                            <i class="mdi mdi-plus"></i> Add New Row
                          </button>
                        </div>
                      </div>
                          <div class="d-flex flex-wrap mt-2 mb-1 custom-item-summary">
                            <span class="badge bg-primary mx-1 my-1" style="font-size: 12px;">Item Amount:  <strong class="mx-2">{{ totals.totalAmount }}</strong></span>
                              <span class="badge bg-primary mx-1 my-1" style="font-size: 12px;">Item Weight:  <strong class="mx-2">{{ totals.totalWeight }}</strong></span>
                              <span class="badge bg-primary mx-1 my-1" style="font-size: 12px;">Item Quantity:  <strong class="mx-2">{{ totals.totalQuantity }}</strong></span>
                          </div>
                      <div class="table-responsive mt-1">
                        <table class="table mb-0">
                            <thead class="table-light">
                                <tr>
                                    <th class="expandcols"></th>
                                    <th>Piece No</th>
                                    <th>Pieces Count</th>
                                    <th>Actual Weight/Piece<span class="mandatory">*</span></th>
                                    <th>Dimensions</th>
                                    <th>Volumetric Weight</th>
                                    <th>Chargeable Weight</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                              <ng-container formArrayName="containers" *ngFor="let pc of containers.controls; let i = index">
                                <ng-container formGroupName="{{i}}">
                                  <tr class="tabl-row-wid">
                                    <td class="expandcols">
                                      <div class="icon-input-container mt-1">
                                        <i [class]="expandedRows[i] ? 'bx bx-chevron-down font-size-20 align-middle' : 'bx bx-chevron-right font-size-20 align-middle'"
                                          style="cursor: pointer" title="Expand" (click)="toggleRowExpansion(i)"></i>
                                      </div>
                                    </td>
                                    <td class="mt-1 pieceno"><input type="hidden" formControlName="piecescounter" [value]="i+1" />{{i+1}}</td>
                                    <td class="piececount">
                                      <input #piecescount type="number" formControlName="piecescount"
                                        class="form-control form-control-sm" (keydown)="totalPiecesValidate($event)" min="1" 
                                        (keydown.enter)="useEnterKey && pc.get('piecescount').valid ? piecesActualWeight.focus() : pc.get('piecescount').markAsTouched()" 
                                        (keyup)="volumetricDetails(pc)"
                                        [ngClass]="{'is-invalid': pc.get('piecescount')?.touched && pc.get('piecescount')?.errors}" />
                                      <div *ngIf="(pc.get('piecescount')?.touched) && pc.get('piecescount')?.errors" class="invalid-feedback">
                                        <span *ngIf="pc.get('piecescount').errors.required">required</span>
                                        <span *ngIf="pc.get('piecescount').value == 0">should be atleast 1</span>
                                      </div>
                                    </td>
                                    <td class="actualweight">
                                      <input #piecesActualWeight type="number" formControlName="piecesactualweight"
                                        class="form-control form-control-sm"
                                        (change)="calculateWeightNew(i);getAWBCharges(category.CUSTOMER)"
                                        (keydown)="piecesValidate($event)" 
                                        (keydown.enter)="useEnterKey && pc.get('piecesactualweight').valid ? piecesLength.focus() : pc.get('piecesactualweight').markAsTouched()" 
                                        [ngClass]="{'is-invalid': pc.get('piecesactualweight')?.touched && pc.get('piecesactualweight')?.errors}" />
                                      <div *ngIf="(pc.get('piecesactualweight')?.touched) && pc.get('piecesactualweight')?.errors"
                                        class="invalid-feedback">
                                        <span *ngIf="pc.get('piecesactualweight').errors.required">required</span>
                                      </div>
                                    </td>
                                    <td class="dimension-width">
                                      <div class="input-group mb-2">
                                        <span class="input-group-text group-label-sm">L
                                        </span>
                                        <input #piecesLength type="number" formControlName="pieceslength"  class="form-control form-control-sm" 
                                          (keydown.enter)="useEnterKey && pc.get('pieceslength').valid ? piecesBreadth.focus() : pc.get('pieceslength').markAsTouched()"
                                          (keyup)="volumetricDetails(pc)"
                                          (keydown)="piecesValidate($event)"
                                          [ngClass]="{'is-invalid': pc.get('pieceslength')?.touched && pc.get('pieceslength')?.errors}" />

                                        <span class="input-group-text group-label-sm">B</span>
                                        <input #piecesBreadth type="number" formControlName="piecesbreadth" #piecesbreadth class="form-control form-control-sm" 
                                          (keydown.enter)="useEnterKey && pc.get('piecesbreadth').valid ? piecesHeight.focus() : pc.get('piecesbreadth').markAsTouched()"
                                          (keyup)="volumetricDetails(pc)"
                                          (keydown)="piecesValidate($event)"
                                          [ngClass]="{'is-invalid': pc.get('piecesbreadth')?.touched && pc.get('piecesbreadth')?.errors}" />

                                        <span class="input-group-text group-label-sm">H</span>
                                        <input #piecesHeight type="number" formControlName="piecesheight" #piecesheight class="form-control form-control-sm" 
                                          (keyup)="volumetricDetails(pc)"
                                          (keydown.enter)="useEnterKey && pc.get('piecesvolumetricweight').disabled? 
                                              (i === containers.controls.length - 1 ? focusSubmitBtn() : focusNextContainer(i + 1)): piecesVolumetricWeight.focus()"
                                          (keydown)="piecesValidate($event)"
                                          [ngClass]="{'is-invalid': pc.get('piecesheight')?.touched && pc.get('piecesheight')?.errors}" />
                                      </div>
                                    </td>
                                    <td class="volweight">
                                      <input #piecesVolumetricWeight type="number" formControlName="piecesvolumetricweight" class="form-control form-control-sm" 
                                        (keyup)="calculateWeightNew()"
                                        (change)="getAWBCharges(category.CUSTOMER)"
                                        (keydown)="piecesValidate($event)"
                                        (keydown.enter)="useEnterKey && (i === containers.controls.length - 1 ? focusSubmitBtn() : focusNextContainer(i + 1))" />
                                    </td>
                                    <td class="volweight">
                                      <input type="number" formControlName="pieceschargeableweight" class="form-control form-control-sm"/>
                                    </td>
                                    <td class="deletepiece">
                                      <i class="bx bx-trash font-size-16 align-middle ms-3" title="Delete"
                                        (click)="removeContainerCustom(i)"></i>
                                    </td>

                                  </tr>
                                  <ng-container *ngIf="isRowExpanded(i)">
                                    <tr>
                                      <td colspan="12">
                                        <div class="card items-card">
                                          <div class="card-header bg-transparent border-bottom text-uppercase">Item Details</div>
                                          <div class="card-body" formGroupName="containeritemsgroup">
                                            <div class="row">
                                              <div class="col-md-3">
                                                <label for="description" class="form-label">Description<span class="mandatory">*</span></label>
                                                <input #descriptionRef type="text" class="form-control form-control-sm" id="description"
                                                  formControlName="description"
                                                  placeholder="Search or Enter Description" [resultTemplate]="rt"
                                                  [inputFormatter]="formatterItemDescription"
                                                  [ngbTypeahead]="searchItemDescription"
                                                  (selectItem)="selectedItemDescriptionEvent(pc, $event)"
                                                  [popupClass]="'desc-popup'" 
                                                  (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.description').valid ? focusItemWeightRef() : pc.get('containeritemsgroup.description').markAsTouched()"
                                                  [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('description')?.touched && pc.get('containeritemsgroup').get('description')?.errors}">
                                                <div *ngIf="pc.get('containeritemsgroup').get('description')?.touched && pc.get('containeritemsgroup').get('description')?.errors"
                                                  class="invalid-feedback">
                                                  <span *ngIf="pc.get('containeritemsgroup').get('description').errors.required">Required</span>
                                                </div>
                                                <div *ngIf="pc.get('containeritemsgroup').get('description')?.touched && pc.get('containeritemsgroup').get('description')?.errors"
                                                  class="invalid-feedback">
                                                  <span *ngIf="pc.get('containeritemsgroup').get('description').errors.maxlength">Maximum 40 characters</span>
                                                </div>
                                                <ng-template #rt let-r="result" let-t="term">
                                                  <ngb-highlight [result]="r.name" [term]="t"></ngb-highlight>
                                                  <span> | {{r['hsncode']}}</span>
                                                </ng-template>
                                              </div>
                                              <div class="col-md-2">
                                                <label for="hsncode" class="form-label">HSN Code</label>
                                                <input #hsnCode type="text" class="form-control form-control-sm" id="hsncode" formControlName="hsncode" 
                                                  (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.hsncode').valid ? focusItemWeightRef() : pc.get('containeritemsgroup.hsncode').markAsTouched()">
                                              </div>
                                              <div class="col-md-1">
                                                <label for="weight" class="form-label">Weight</label>
                                                <input #weightRef type="number" class="form-control form-control-sm" id="weight" formControlName="weight" 
                                                  (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.weight').valid ? quantity.focus() : pc.get('containeritemsgroup.weight').markAsTouched()" appLimitDigits [length] = "13"
                                                  [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('weight')?.touched && pc.get('containeritemsgroup').get('weight')?.errors}">
                                                <div *ngIf="pc.get('containeritemsgroup').get('weight')?.touched && pc.get('containeritemsgroup').get('weight')?.errors" class="invalid-feedback">
                                                  <span *ngIf="pc.get('containeritemsgroup').get('weight').errors.pattern">Maximum 9 digits and atleast 3 decimals</span>
                                                </div>
                                              </div>
                                              <div class="col-md-2">
                                                <label for="unit" class="form-label">Unit</label>
                                                <ng-select #unit formControlName="unit" [items]="containerItemUnitOptions"
                                                  bindLabel="name" [bindValue]="'code'" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" 
                                                  (click)="quantity.focus()" (keydown.enter)="quantity.focus()"></ng-select>
                                              </div>
                                              <div class="col-md-1">
                                                <label for="quantity" class="form-label">Quantity<span class="mandatory">*</span></label>
                                                <input #quantity type="number" class="form-control form-control-sm" id="quantity" appLimitDigits [length] = "3"
                                                  formControlName="quantity" (keyup)="calculateItemAmount(pc)"
                                                  (keydown)="onKeyDown($event)" 
                                                  (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.quantity').valid ? rate.focus() : pc.get('containeritemsgroup.quantity').markAsTouched()"
                                                  [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('quantity')?.touched && pc.get('containeritemsgroup').get('quantity')?.errors}">
                                                <div *ngIf="pc.get('containeritemsgroup').get('quantity')?.touched && pc.get('containeritemsgroup').get('quantity')?.errors" class="invalid-feedback">
                                                  <span *ngIf="pc.get('containeritemsgroup').get('quantity').errors.required">Required</span>
                                                </div>

                                                <div *ngIf="pc.get('containeritemsgroup').get('quantity')?.touched && pc.get('containeritemsgroup').get('quantity')?.errors" class="invalid-feedback">
                                                  <span *ngIf="pc.get('containeritemsgroup').get('quantity').errors.pattern">Maximum 3 digits only</span>
                                                  <span *ngIf="pc.get('containeritemsgroup').get('quantity').errors.nonZero">Quantity cannot be zero</span>
                                                </div>

                                              </div>
                                              <div class="col-md-1">
                                                <label for="rate" class="form-label">Rate<span class="mandatory">*</span></label>
                                                <input #rate type="number" class="form-control form-control-sm" id="rate" appLimitDigits [length] = "14"
                                                  formControlName="rate" (keyup)="calculateItemAmount(pc)" 
                                                  (keydown.enter)="useEnterKey && pc.get('containeritemsgroup.rate').valid ? pieceAddBtn.nativeElement.focus() : pc.get('containeritemsgroup.rate').markAsTouched()"
                                                  [ngClass]="{'is-invalid': pc.get('containeritemsgroup').get('rate')?.touched && pc.get('containeritemsgroup').get('rate')?.errors}">
                                                <div *ngIf="pc.get('containeritemsgroup').get('rate')?.touched && pc.get('containeritemsgroup').get('rate')?.errors" class="invalid-feedback">
                                                  <span *ngIf="pc.get('containeritemsgroup').get('rate').errors.required">Required</span>
                                                </div>
                                                <div *ngIf="pc.get('containeritemsgroup').get('rate')?.touched && pc.get('containeritemsgroup').get('rate')?.errors" class="invalid-feedback">
                                                  <span *ngIf="pc.get('containeritemsgroup').get('rate').errors.pattern">Maximum 10 digits and atleast 3 decimals</span>
                                                </div>
                                              </div>
                                              <div class="col-md-1">
                                                <label for="amount" class="form-label">Amount</label>
                                                <input #amount type="number" class="form-control form-control-sm" formControlName="amount" 
                                                  (keydown.enter)="useEnterKey && pc.get('containeritemsgroup').get('amount').valid ? pieceAddBtn.nativeElement.focus() : pc.get('containeritemsgroup').get('amount').markAsTouched()">
                                              </div>
                                              <div class="col-1 mt-3">
                                                <label class="form-label"></label>
                                                <ng-container *ngIf="!pc.get('containeritemsgroup').get('editmode').value">
                                                  <button #pieceAddBtn type="button" class="btn btn-info btn-label btn-sm w-xs btn-only-icon d-inline-block mt-1"
                                                    (click)="addSubItem(i, pc.get('containeritemsgroup'))"
                                                    (keydown.enter)="addSubItem(i, pc.get('containeritemsgroup'))">
                                                      <i class="bx bx-plus label-icon "></i>Add
                                                  </button>
                                                </ng-container>
                                                <ng-container *ngIf="pc.get('containeritemsgroup').get('editmode').value">
                                                  <button type="button" class="btn btn-success btn-label btn-sm w-xs btn-only-icon d-inline-block mt-1"
                                                    (click)="updateSubItem(pc.get('containeritemsgroup'))"
                                                    (keydown.enter)="updateSubItem(pc.get('containeritemsgroup'))">
                                                      <i class="bx bx-save label-icon "></i>Save</button>

                                                  <button type="button" class="btn btn-danger btn-label btn-sm w-xs btn-only-icon d-inline-block mt-1"
                                                    (click)="cancelUpdateSubItem(pc.get('containeritemsgroup'))">
                                                      <i class="bx bx-exit label-icon "></i>Cancel</button>
                                                </ng-container>

                                                <!-- <button type="button" class="btn btn-primary btn-sm d-flex" (click)="addSubItem(i, null)">
                                                        <i class="bx bx-plus font-size-16 me-1"></i>
                                                        Add Item
                                                    </button> -->
                                                <!-- <button type="button" class="btn btn-warning btn-label btn-sm w-xs btn-only-icon">
                                                      <i class="bx bx-edit label-icon "></i> Edit</button>
                                                    <button type="button" class="btn btn-info btn-label btn-sm w-xs btn-only-icon">
                                                      <i class="bx bx-save label-icon "></i> Save</button> -->
                                              </div>
                                              <div class="col-9">
                                                <div class="d-flex justify-content-end">
                                                  <!-- <button type="button" class="btn btn-warning btn-label btn-sm w-xs btn-only-icon">
                                                        <i class="bx bx-edit label-icon "></i> Edit</button>
                                                      <button type="button" class="btn btn-info btn-label btn-sm w-xs btn-only-icon">
                                                        <i class="bx bx-save label-icon "></i> Save</button> -->
                                                </div>
                                              </div>
                                            </div>
                                            <div class="row mt-3">
                                              <div class="col-12">
                                                <div class="table-responsive items-table">
                                                  <table class="table table-sm m-0">
                                                    <thead class="table-light display-table-row">
                                                      <tr>
                                                        <th style="width: 400px;">Description</th>
                                                        <th style="width: 150px;">HSN Code</th>
                                                        <th>Weight</th>
                                                        <th>Unit</th>
                                                        <th>Quantity</th>
                                                        <th>Rate</th>
                                                        <th>Amount</th>
                                                        <th></th>
                                                      </tr>
                                                    </thead>
                                                    <tbody style="max-height: 310px; overflow-y: auto;">
                                                      <ng-container formArrayName="subitems"
                                                        *ngFor="let item of subItem(i).controls; let ci=index">
                                                        <tr [formGroupName]="ci" class="tabl-row-wid">
                                                          <td style="width: 400px;">
                                                            {{item.value.itemdescription}}
                                                          </td>
                                                          <td style="width: 150px;">
                                                            {{item.value.itemhsncode}}
                                                          </td>
                                                          <td>
                                                            {{item.value.itemweight}}
                                                          </td>
                                                          <td>
                                                            {{item.value.itemunit}}
                                                          </td>
                                                          <td>
                                                            {{item.value.itemquantity}}
                                                          </td>
                                                          <td>
                                                            {{item.value.itemrate}}
                                                          </td>
                                                          <td>
                                                            {{item.value.itemamount}}
                                                          </td>
                                                          <td class="d-flex">
                                                            <i class="bx bx-edit font-size-16 align-middle me-2"
                                                              (click)="editSubItem(pc.get('containeritemsgroup'), item, ci)"></i>
                                                            <i class="bx bx-trash font-size-16 align-middle me-2"
                                                              (click)="removeSubItem(i, ci)"></i>
                                                          </td>
                                                        </tr>
                                                      </ng-container>
                                                      <ng-container *ngIf="subItem(i).controls.length === 0">
                                                        <tr>
                                                          <td colspan="12" class="no-data-available">No data available</td>
                                                        </tr>
                                                      </ng-container>
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </td>
                                    </tr>
                                  </ng-container>
                                </ng-container>
                              </ng-container>
                            </tbody>
                        </table>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template [formGroup]="proformaForm" #ProformaContent>
            <div class="row">
              <div class="col-md-1">
                <div class="mb-2">
                  <label for="csbtype" class="form-label">CSB Type</label>
                  <ng-select id="csbtype" #csbtype formControlName="ddlCSBType" placeholder="Select" [appendTo]="'body'" [openOnEnter]="false"
                    (change)="onCsbChange()" [clearable]="false" 
                    (keydown.enter)="useEnterKey && invoiceterm.focus()">
                    <ng-option value="csb4">CSB 4</ng-option>
                    <ng-option value="csb5">CSB 5</ng-option>
                    <ng-option value="commercial">Commercial</ng-option>
                  </ng-select>
                </div>
              </div>

              <div class="col-md-2">
                <div class="mb-2">
                  <label for="invoiceterm" class="form-label">Invoice Term</label>
                  <ng-select id="invoiceterm" #invoiceterm [items]="invoiceTermOptions" bindLabel="name" [bindValue]="'id'"
                    formControlName="ddlInvoiceTerm" [appendTo]="'body'" [openOnEnter]="false" placeholder="Select" (change)="onPerformaChange()"
                    (keydown.enter)="useEnterKey && btngstinvoice1.focus()" 
                    class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom">
                  </ng-select>
                </div>
              </div>

              <div class="col-md-1">
                <div class="mb-2">
                  <label for="gstinvoice" class="form-label">GST Invoice &nbsp;</label> <br>
                  <div role="group" aria-label="GST invoice" class="btn-group btn-group-sm">
                    <input type="radio" id="btngstinvoice1" #btngstinvoice1 autocomplete="off" checked="" class="btn-check" value="Yes"
                      formControlName="ddlGSTInvoice" (change)="onPerformaChange()" 
                    (keydown.enter)="useEnterKey && btngstinvoice2.focus()" />
                    <label for="btngstinvoice1" class="btn btn-outline-secondary">Yes</label>
                    <input type="radio" id="btngstinvoice2" #btngstinvoice2 autocomplete="off" class="btn-check" value="No"
                      formControlName="ddlGSTInvoice" (change)="onPerformaChange()" 
                    (keydown.enter)="useEnterKey && invoiceno.focus()" />
                    <label for="btngstinvoice2" class="btn btn-outline-secondary">No</label>
                  </div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="mb-2">
                  <label for="invoiceno" class="form-label">Invoice No.</label>
                  <input type="text" class="form-control form-control-sm" id="invoiceno" #invoiceno maxlength="30"
                    formControlName="txtCommercialInvoiceNo" 
                    (keydown.enter)="useEnterKey && proformaForm.get('txtCommercialInvoiceNo').valid ? invoicedate.focus() : proformaForm.get('txtCommercialInvoiceNo').markAsTouched()"
                    [ngClass]="{'is-invalid':(isFormSubmitted || proformaForm.get('txtCommercialInvoiceNo').touched) && proformaForm.get('txtCommercialInvoiceNo').errors}" />
                  <div
                    *ngIf=" (isFormSubmitted || proformaForm.get('txtCommercialInvoiceNo').touched) && proformaForm.get('txtCommercialInvoiceNo').errors"
                    class="invalid-feedback">
                    <span *ngIf=" proformaForm.get('txtCommercialInvoiceNo').errors.pattern">Invoice No. max
                      length is 30 characters.</span>
                  </div>
                </div>
              </div>

              <div class="col-md-1">
                <div class="mb-2">
                  <label for="invoicedate" class="form-label">Invoice Date</label>
                  <input type="date" class="form-control form-control-sm" id="invoicedate" #invoicedate formControlName="ddlInvoiceDate"
                    (change)="onPerformaChange()" 
                    (keydown.enter)="useEnterKey && proformaForm.get('txtDepartmentNo').disabled? exportreason.focus(): departmentNo.focus()" />
                </div>
              </div>

              <div class="col-md-2">
                <div class="mb-2">
                  <label for="departmentno" class="form-label">Department No</label>
                  <input #departmentNo type="text" class="form-control form-control-sm" id="departmentno" formControlName="txtDepartmentNo" 
                  (keydown.enter)="useEnterKey && exportreason.focus()"/>
                </div>
              </div>

              <div class="col-md-3">
                <div class="mb-2">
                  <label for="exportreason" class="form-label">Export Reason</label>
                  <ng-select id="exportreason" #exportreason placeholder="Select" [appendTo]="'body'" [openOnEnter]="false" formControlName="ddlExportReason"
                    [items]="performaExportReasonOptions" bindLabel="name" [bindValue]="'name'" 
                    (keydown.enter)="useEnterKey && buyerdetails.focus()">
                  </ng-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 mb-4">
                <label for="buyerdetails" style="margin-right: 0.5%;margin-left: 0.4%;">Buyer Details</label>
                <input type="checkbox" id="buyerdetails" #buyerdetails formControlName="chkBuyerDetails" class="form-check-input"
                  (change)="awbBuyerDetails()" 
                    (keydown.enter)="useEnterKey && (isAwbBuyerDetailsChk? buyerName.nativeElement.focus(): focusSubmitBtn())">
              </div>
            </div>
            <div formGroupName="csbDetails" *ngIf="isCsbType">
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="lutigst" class="form-label">LUT/IGST</label>
                    <ng-select id="lutigst" #lutigst formControlName="ddlLutIgst" placeholder="Select" [items]="lutIgstOptions"
                      bindLabel="name" [bindValue]="'name'" [appendTo]="'body'" [openOnEnter]="false" (change)="onPerformaChange()" 
                    (keydown.enter)="useEnterKey && totaligst.focus()">
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="totaligst" class="form-label">Total IGST</label>
                    <input type="number" class="form-control form-control-sm" id="totaligst" #totaligst formControlName="txtTotalIgst"
                      (change)="onPerformaChange()" (keydown)="peformaNumberValidate($event)" 
                    (keydown.enter)="useEnterKey && bankadcode.focus()" />
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="bankadcode" class="form-label">Bank AD Code</label>
                    <input type="text" class="form-control form-control-sm" id="bankadcode" #bankadcode formControlName="txtBankAdCode"
                      maxlength="30" 
                    (keydown.enter)="useEnterKey && awbForm.get('txtBankAdCode').valid ? bankacc.focus() : awbForm.get('txtBankAdCode').markAsTouched()"
                      [ngClass]="{ 'is-invalid':(isFormSubmitted ||proformaForm.get('csbDetails.txtBankAdCode').touched) && proformaForm.get('csbDetails.txtBankAdCode').errors}" />
                    <div
                      *ngIf="(isFormSubmitted ||proformaForm.get('csbDetails.txtBankAdCode').touched) &&proformaForm.get('csbDetails.txtBankAdCode').errors"
                      class="invalid-feedback">
                      <span *ngIf="proformaForm.get('csbDetails.txtBankAdCode').errors.maxlength">Bank AD Code max
                        length is 30 characters.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="bankacc" class="form-label">Bank Account</label>
                    <input type="text" class="form-control form-control-sm" id="bankacc" #bankacc formControlName="txtBankAccount"
                      maxlength="30" 
                    (keydown.enter)="useEnterKey && awbForm.get('txtBankAccount').valid ? bankifsc.focus() : awbForm.get('txtBankAccount').markAsTouched()"
                      [ngClass]="{'is-invalid':(isFormSubmitted ||proformaForm.get('csbDetails.txtBankAccount').touched) && proformaForm.get('csbDetails.txtBankAccount').errors}" />
                    <div
                      *ngIf="(isFormSubmitted ||proformaForm.get('csbDetails.txtBankAccount').touched) &&proformaForm.get('csbDetails.txtBankAccount').errors"
                      class="invalid-feedback">
                      <span *ngIf="proformaForm.get('csbDetails.txtBankAccount').errors.maxlength">Bank Account max
                        length is 30 characters.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="bankifsc" class="form-label">Bank IFSC</label>
                    <input type="text" class="form-control form-control-sm" id="bankifsc" #bankifsc formControlName="txtBankIfsc"
                      maxlength="30" 
                    (keydown.enter)="useEnterKey && awbForm.get('txtBankIfsc').valid ? lutbondno.focus() : awbForm.get('txtBankIfsc').markAsTouched()"
                      [ngClass]="{'is-invalid':(isFormSubmitted ||proformaForm.get('csbDetails.txtBankIfsc').touched) && proformaForm.get('csbDetails.txtBankIfsc').errors}" />
                    <div
                      *ngIf="(isFormSubmitted ||proformaForm.get('csbDetails.txtBankIfsc').touched) &&proformaForm.get('csbDetails.txtBankIfsc').errors"
                      class="invalid-feedback">
                      <span *ngIf="proformaForm.get('csbDetails.txtBankIfsc').errors.maxlength">Bank IFSC max length
                        is
                        30 characters.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="lutbondno" class="form-label">Bond No.</label>
                    <input type="text" class="form-control form-control-sm" id="lutbondno" #lutbondno formControlName="txtLutBondNo"
                      maxlength="30" 
                    (keydown.enter)="useEnterKey && awbForm.get('txtLutBondNo').valid ? exchangerate.focus() : awbForm.get('txtLutBondNo').markAsTouched()"
                      [ngClass]="{'is-invalid':(isFormSubmitted ||proformaForm.get('csbDetails.txtLutBondNo').touched) && proformaForm.get('csbDetails.txtLutBondNo').errors}" />
                    <div
                      *ngIf="(isFormSubmitted ||proformaForm.get('csbDetails.txtLutBondNo').touched) &&proformaForm.get('csbDetails.txtLutBondNo').errors"
                      class="invalid-feedback">
                      <span *ngIf="proformaForm.get('csbDetails.txtLutBondNo').errors.maxlength">Bond No max
                        length
                        is 30 characters.</span>
                    </div>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="exchangerate" class="form-label">Exchange Rate</label>
                    <input type="number" class="form-control form-control-sm" id="exchangerate" #exchangerate formControlName="txtExchangeRate"
                      
                    (keydown.enter)="useEnterKey && awbForm.get('txtExchangeRate').valid ? firm.focus() : awbForm.get('txtExchangeRate').markAsTouched()" />
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="mb-2">
                    <label for="firm" class="form-label">Firm</label>
                    <ng-select id="firm" #firm formControlName="ddlFirm" placeholder="Select" [items]="firmOptions" bindLabel="name"
                      [bindValue]="'name'" [appendTo]="'body'" [openOnEnter]="false" 
                    (keydown.enter)="useEnterKey && awbForm.get('ddlFirm').valid ? nfei.focus() : awbForm.get('ddlFirm').markAsTouched()">
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="mb-2">
                    <label for="nfei" class="form-label">NFEI</label>
                    <div class="form-check form-switch form-switch-md">
                      <input type="checkbox" id="nfei" #nfei class="form-check-input" formControlName="nfeiCheck" 
                    (keydown.enter)="useEnterKey && awbForm.get('nfeiCheck').valid ? payofigst.focus() : awbForm.get('nfeiCheck').markAsTouched()">
                    </div>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="mb-2">
                    <label for="payofigst" class="form-label">Pay of IGST</label>
                    <div class="form-check form-switch form-switch-md">
                      <input type="checkbox" id="payofigst" #payofigst class="form-check-input" formControlName="payOfIgstCheck"
                        
                    (keydown.enter)="useEnterKey && awbForm.get('payOfIgstCheck').valid ? ecommerce.focus() : awbForm.get('payOfIgstCheck').markAsTouched()">
                    </div>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="mb-2">
                    <label for="ecommerce" class="form-label">E-Commerce</label>
                    <div class="form-check form-switch form-switch-md">
                      <input type="checkbox" id="ecommerce" #ecommerce class="form-check-input" formControlName="eCommerceCheck"
                        (change)="onPerformaChange()" 
                    (keydown.enter)="useEnterKey && awbForm.get('eCommerceCheck').valid ? meisschema.focus() : awbForm.get('eCommerceCheck').markAsTouched()">
                    </div>
                  </div>
                </div>

                <div class="col-md-1">
                  <div class="mb-2">
                    <label for="meisschema" class="form-label">MEIS Scheme</label>
                    <div class="form-check form-switch form-switch-md">
                      <input type="checkbox" id="meisschema" #meisschema class="form-check-input" formControlName="meisSchemaCheck"
                        (change)="onPerformaChange()" 
                    (keydown.enter)="useEnterKey && awbForm.get('meisSchemaCheck').valid ? buyerdetails.focus() : awbForm.get('meisSchemaCheck').markAsTouched()">
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div formGroupName="buyerDetails" *ngIf="isAwbBuyerDetailsChk">
              <div class="row">
                <div class="col-md-12">
                  <div class="row">
                    <div class="col-md-2">
                      <div class="mb-2">
                        <label class="form-label">Name </label>
                        <input #buyerName type="text" class="form-control form-control-sm" formControlName="txtName" 
                          (keydown.enter)="useEnterKey && proformaForm.get('buyerDetails').get('txtName').valid ? buyerContactPerson.focus() : proformaForm.get('buyerDetails').get('txtName').markAsTouched()">
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="mb-2">
                        <label class="form-label">Contact Person </label>
                        <input #buyerContactPerson type="text" class="form-control form-control-sm" formControlName="txtPerson" 
                          (keydown.enter)="useEnterKey && proformaForm.get('buyerDetails').get('txtPerson').valid ? buyerEmail.focus() : proformaForm.get('buyerDetails').get('txtPerson').markAsTouched()">
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="mb-2">
                        <label class="form-label">Email </label>
                        <input #buyerEmail type="text" class="form-control form-control-sm" formControlName="txtEmail" maxlength="150"
                          (keydown.enter)="useEnterKey && proformaForm.get('buyerDetails').get('txtEmail').valid ? buyerIECNo.focus() : proformaForm.get('buyerDetails').get('txtEmail').markAsTouched()"
                          [ngClass]="{'is-invalid': (isFormSubmitted || proformaForm.get('buyerDetails.txtEmail').touched) && proformaForm.get('buyerDetails.txtEmail').errors}">
                        <div
                          *ngIf="(isFormSubmitted || proformaForm.get('buyerDetails.txtEmail').touched) && proformaForm.get('buyerDetails.txtEmail').errors"
                          class="invalid-feedback">
                          <span *ngIf="proformaForm.get('buyerDetails.txtEmail').errors.pattern">Invalid Email</span>
                          <span *ngIf="proformaForm.get('buyerDetails.txtEmail').errors.maxlength">Email max length is
                            150
                            characters</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="mb-2">
                        <label class="form-label">IEC No </label>
                        <input #buyerIECNo type="text" class="form-control form-control-sm" formControlName="txtIECNo" 
                        (keydown.enter)="useEnterKey && proformaForm.get('buyerDetails').get('txtIECNo').valid ? buyerAddress.focus() : proformaForm.get('buyerDetails').get('txtIECNo').markAsTouched()">
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <label class="form-label">Address</label>
                      <textarea #buyerAddress formControlName="txtAddress" class="form-control custom-textbox" maxlength="100"
                      (keydown.enter)="useEnterKey && proformaForm.get('buyerDetails').get('txtAddress').valid ? focusSubmitBtn() : proformaForm.get('buyerDetails').get('txtAddress').markAsTouched()"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </ng-template>

          <ng-template #ChargesContent>
            <div class="row">
              <app-shared-charge #appSharedCustomercharge [chargeForm]="chargeForm" [forwardingInfo]="forwardingInfoTab" [(customerRowData)]="customerRowData"
                (customerDataList)="addData($event)" (chargeData)="addChargeData($event, 'Customer')" (chargesList)="getchargesList($event)"
                [(chargesOptions)]="chargeList" [(customerConfig)]="customerConfig" [awbForm]="awbForm" 
                (focusEmit)="focusSubmitBtn()">
              </app-shared-charge>
            </div>
          </ng-template>

          <ng-template [formGroup]="specialServicesForm" #SpecialServicesContent>
            <div class="row">
              <div class="d-flex flex-grow-1">
                <div class="card flex-grow-1">
                  <div class="card-body ms-2 me-2">
                    <div class="row">
                      <div class="col-md-12">
                        <div class="row">
                          <div class="col-md-2 d-flex-shipment-services">
                            <div class="mb-2">
                              <label for="dangerousGoodsCheck" class="form-label">Dangerous Goods&nbsp;</label>
                              <div role="group" aria-label="Item fuel" class="btn-group btn-group-sm d-flex">
                                <input type="radio" id="btnfuelradio1" #btnfuelradio1 autocomplete="off" checked class="btn-check" value="Yes"
                                  (change)="SpecialServicesCheckChange(['dangerousGoodsCheck'])" formControlName="dangerousGoodsCheck" 
                                  (keydown.enter)="useEnterKey && btnfuelradio2.focus()"/>
                                <label for="btnfuelradio1" class="btn btn-outline-secondary">Yes</label>
                                <input type="radio" id="btnfuelradio2" #btnfuelradio2 autocomplete="off" class="btn-check" value="No"
                                  (change)="SpecialServicesCheckChange(['dangerousGoodsCheck'])" formControlName="dangerousGoodsCheck"
                                  (keydown.enter)="useEnterKey && dangerousGoods.focus()"/>
                                <label for="btnfuelradio2" class="btn btn-outline-secondary">No</label>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-2 d-flex-shipment-services">
                            <div class="mb-2">
                              <label for="dangerousGoods" class="form-label">Goods Type</label>
                              <ng-select id="dangerousGoods" #dangerousGoods formControlName="ddldangerousGoods" placeholder="Select"
                                [items]="dangerousGoodsList" [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'name'" [clearable]="false"
                                class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                                [ngClass]="{'disabled': awbForm.get('specialServicesInfo.ddldangerousGoods')?.disabled}"
                                (keydown.enter)="useEnterKey && btnfuelradio3.focus()">
                              </ng-select>
                            </div>
                          </div>

                          <div class="col-md-2 d-flex-shipment-services">
                            <div class="mb-2">
                              <label for="dryIceCheck" class="form-label">Dry Ice&nbsp;</label>
                              <div role="group" aria-label="Item fuel" class="btn-group btn-group-sm d-flex">
                                <input type="radio" id="btnfuelradio3" #btnfuelradio3 autocomplete="off" checked class="btn-check" value="Yes"
                                  (change)="SpecialServicesCheckChange(['dryIceCheck'])" formControlName="dryIceCheck" 
                                  (keydown.enter)="useEnterKey && btnfuelradio4.focus()"/>
                                <label for="btnfuelradio3" class="btn btn-outline-secondary">Yes</label>
                                <input type="radio" id="btnfuelradio4" #btnfuelradio4 autocomplete="off" class="btn-check" value="No"
                                  (change)="SpecialServicesCheckChange(['dryIceCheck'])" formControlName="dryIceCheck" 
                                  (keydown.enter)="useEnterKey && dryIceWeight.focus()"/>
                                <label for="btnfuelradio4" class="btn btn-outline-secondary">No</label>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-2 d-flex-shipment-services">
                            <div class="mb-2">
                              <label for="dryIceWeight" class="form-label">Dry Ice Weight</label>
                              <input type="number" class="form-control form-control-sm" id="dryIceWeight" #dryIceWeight
                                formControlName="txtDryIceWeight" 
                                (keydown.enter)="useEnterKey && btnfuelradio5.focus()"/>
                            </div>
                          </div>

                          <div class="col-md-2 d-flex-shipment-services">
                            <div class="mb-2">
                              <label for="insuranceCoverCheck" class="form-label">Insurance Coverage&nbsp;</label>
                              <div role="group" aria-label="Item fuel" class="btn-group btn-group-sm d-flex">
                                <input type="radio" id="btnfuelradio5" #btnfuelradio5 autocomplete="off" checked class="btn-check" value="Yes"
                                  (change)="SpecialServicesCheckChange(['insuranceCoverCheck'])"
                                  formControlName="insuranceCoverCheck" 
                                  (keydown.enter)="useEnterKey && btnfuelradio6.focus()"/>
                                <label for="btnfuelradio5" class="btn btn-outline-secondary">Yes</label>
                                <input type="radio" id="btnfuelradio6" #btnfuelradio6 autocomplete="off" class="btn-check" value="No"
                                  (change)="SpecialServicesCheckChange(['insuranceCoverCheck'])"
                                  formControlName="insuranceCoverCheck" 
                                  (keydown.enter)="useEnterKey && insuranceCoverValue.focus()"/>
                                <label for="btnfuelradio6" class="btn btn-outline-secondary">No</label>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-2 d-flex-shipment-services">
                            <div class="mb-2">
                              <label for="insuranceCoverValue" class="form-label">Coverage Value (INR)</label>
                              <input type="number" class="form-control form-control-sm" id="insuranceCoverValue" #insuranceCoverValue
                                formControlName="txtInsuranceCoverValue" 
                                (keydown.enter)="useEnterKey && bookingConfirmNo.focus()"/>
                            </div>
                          </div>
                        </div>

                      <div class="row">
                        <div class="col-md-4">
                          <div class="mb-2">
                            <label for="bookingConfirmNo" class="form-label">Booking Confirmation No.</label>
                            <input type="text" class="form-control form-control-sm" id="bookingConfirmNo" #bookingConfirmNo
                              formControlName="txtBookingConfirmationNo" 
                              (keydown.enter)="useEnterKey && outputFormat.focus()"/>
                          </div>
                        </div>
                        <div class="col-md-4">
                          <div class="mb-2">
                            <label for="outputFormat" class="form-label">Output Format</label>
                            <ng-select id="outputFormat" #outputFormat formControlName="ddlOutputFormat" placeholder="Select"
                              [items]="outputFormatList" [appendTo]="'body'" [openOnEnter]="false" bindLabel="name" [bindValue]="'name'"
                              class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                              (keydown.enter)="useEnterKey && billShipmentTo.focus()">
                            </ng-select>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-3">
                          <div class="mb-2">
                            <label for="billShipmentTo" class="form-label">Bill Shipment To</label>
                            <ng-select id="billShipmentTo" #billShipmentTo formControlName="ddlbillShipmentTo" placeholder="Select"
                              (change)="SpecialServicesCheckChange(['ddlbillShipmentTo'])"
                              [items]="billShipmentToAndDutiesPaidByList" [appendTo]="'body'" [openOnEnter]="false" bindLabel="name"
                              [bindValue]="'name'"
                              class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                              (keydown.enter)="useEnterKey && billToAccNo.focus()">
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="mb-2">
                            <label for="billToAccNo" class="form-label">Account No.</label>
                            <input type="text" class="form-control form-control-sm" id="billToAccNo" #billToAccNo
                              formControlName="txtBillShipmentToAccNo" maxLength="30"
                              (keydown.enter)="useEnterKey && taxAndDutiesPaidBy.focus()"/>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="mb-2">
                            <label for="taxAndDutiesPaidBy" class="form-label">Tax/Duties Paid By</label>
                            <ng-select id="taxAndDutiesPaidBy" #taxAndDutiesPaidBy formControlName="ddlTaxAndDutiesPaidBy" placeholder="Select"
                              (change)="SpecialServicesCheckChange(['ddlTaxAndDutiesPaidBy'])"
                              [items]="billShipmentToAndDutiesPaidByList" [appendTo]="'body'" [openOnEnter]="false" bindLabel="name"
                              [bindValue]="'name'"
                              class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"
                              (keydown.enter)="useEnterKey && taxAndDutyAccNo.focus()">
                            </ng-select>
                          </div>
                        </div>
                        <div class="col-md-3">
                          <div class="mb-2">
                            <label for="taxAndDutyAccNo" class="form-label">Account No.</label>
                            <input type="text" class="form-control form-control-sm" id="taxAndDutyAccNo" #taxAndDutyAccNo
                              formControlName="txtTaxAndDutiesAccNo" maxLength="30"
                              (keydown.enter)="useEnterKey && received.focus()"/>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="d-flex flex-grow-1">
              <div class="card flex-grow-1">
                <div class="filter-group ms-4">
                  <div class="filter-chip action-group"
                    [ngClass]="{'enabled-background': specialServicesForm.get('bsoBrokerCheck').value?? false}">
                    <input id="received" #received class="form-check-input me-2 pointer custom-check-width" type="checkbox"
                      formControlName="bsoBrokerCheck" (change)="SpecialServicesCheckChange(['bsoBrokerCheck'])" 
                      (keydown.enter)="useEnterKey && appBsoBrokerLocation.focusFirstField()"/>
                    <label for="received" class="form-label pointer top-0">BSO Broker</label>
                  </div>
                </div>
                <div class="card-body ms-2 me-2">
                  <div class="row">
                    <div class="col-md-12">
                      <app-location #appBsoBrokerLocation formGroupName="bsoBrokerlocationdetails" [formSubmitted]="isFormSubmitted"
                        [location]="bsoBrokerLocationInfo" (pincodeChild)="'getPincodeOdaDetails()'"
                        (getLocation)="getBrokerLocation($event)" 
                        (focusEmit)="focusSubmitBtn()"></app-location>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>

          <ng-template formGroupName="shipmentinfo" #ShipmentContent>
            <div class="card-body">
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="fieldexecutive" class="form-label">Field Executive</label>
                    <ng-select id="fieldexecutive" #fieldExecutive placeholder="Select" formControlName="ddlFieldExecutive" [appendTo]="'body'" [openOnEnter]="false"
                      (keydown.enter)="useEnterKey && salesExecutive.focus()" [items]="fieldExecutiveList" bindLabel="username" [bindValue]="'id'"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom"></ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="salesExecutive" class="form-label">Sales Executive </label>
                    <ng-select id="salesExecutive" #salesExecutive formControlName="ddlSalesExecutive" placeholder="Select"
                      [items]="salesExecutiveList" [appendTo]="'body'" [openOnEnter]="false" bindLabel="username" [bindValue]="'id'" 
                      (keydown.enter)="useEnterKey && expecteddate.focus()"
                      class="ng-select ng-select-single ng-select-searchable ng-select-clearable ng-select-bottom">
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="expecteddate" class="form-label">Expected Delivery Date</label>
                    <input type="datetime-local" class="form-control form-control-sm" id="expecteddate" #expecteddate
                    (keydown.enter)="useEnterKey && focusSubmitBtn()"
                    [min]="awbForm.get('txtDateTime').value" max="3000-12-31T23:59" formControlName="txtExpectedDeliveryDate" />
                  </div>
                </div>

              <div class="col-md-2">
                <div class="mb-2">
                  <label for="content" class="form-label">Run No</label>
                  <input type="text" class="form-control form-control-sm" formControlName="txtRunNo" maxLength="30">
                </div>
              </div>

              <div class="col-md-4">
                <div class="mb-2">
                  <label for="specialinstructions" class="form-label">Special Instructions</label>
                  <input type="text" id="specialinstructions" class="form-control form-control-sm" formControlName="txtSpecialInstruction">
                </div>
              </div>

            </div>
          </div>
        </ng-template>

          <ng-template formGroupName="forwardinginfo" #ForwardingContent>
            <div class="card-body">
              <div class="row">
                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="deliveryawb" class="form-label">Delivery AWB No.</label>
                    <input type="text" class="form-control form-control-sm" id="deliveryawb" #deliveryawb formControlName="txtDeliveryAwb"
                      maxlength="30" 
                    (keydown.enter)="useEnterKey && awbForm.get('forwardinginfo.txtDeliveryAwb').valid ? forwardingawb.focus() : awbForm.get('forwardinginfo.txtDeliveryAwb').markAsTouched()"
                      [ngClass]="{'is-invalid':(isFormSubmitted || awbForm.get('forwardinginfo.txtDeliveryAwb').touched) &&awbForm.get('forwardinginfo.txtDeliveryAwb').errors}" />
                    <div
                      *ngIf="(isFormSubmitted ||awbForm.get('forwardinginfo.txtDeliveryAwb').touched) && awbForm.get('forwardinginfo.txtDeliveryAwb').errors"
                      class="invalid-feedback">
                      <span *ngIf=" awbForm.get('forwardinginfo.txtDeliveryAwb').errors.maxlength">Delivery AWB No max
                        length is 30 characters</span>
                      <span *ngIf=" awbForm.get('forwardinginfo.txtDeliveryAwb').errors.pattern">Invalid Pattern.Only
                        accept alphanumeric value.</span>
                    </div>
                  </div>
                </div>

                <div class=" col-md-2">
                  <div class="mb-2">
                    <label for="forwardingawb" class="form-label">Forwarding AWB No.</label>
                    <input type="text" class="form-control form-control-sm" id="forwardingawb" #forwardingawb formControlName="txtForwardingAwb"
                      maxlength="30" 
                      (keydown.enter)="useEnterKey && awbForm.get('forwardinginfo.txtForwardingAwb').valid ? deliveryproduct.focus() : awbForm.get('forwardinginfo.txtForwardingAwb').markAsTouched()"
                      [ngClass]="{'is-invalid':(isFormSubmitted || awbForm.get('forwardinginfo.txtForwardingAwb').touched) &&awbForm.get('forwardinginfo.txtForwardingAwb').errors}" />
                    <div
                      *ngIf="(isFormSubmitted ||awbForm.get('forwardinginfo.txtForwardingAwb').touched) && awbForm.get('forwardinginfo.txtForwardingAwb').errors"
                      class="invalid-feedback">
                      <span *ngIf=" awbForm.get('forwardinginfo.txtForwardingAwb').errors.maxlength">Forwarding AWB No
                        max length is 30 characters</span>
                      <span *ngIf=" awbForm.get('forwardinginfo.txtForwardingAwb').errors.pattern">Invalid
                        Pattern.Only
                        accept alphanumeric value.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="deliveryproduct" class="form-label">Delivery Product</label>
                    <ng-select #deliveryproduct id="deliveryproduct" placeholder="Select" formControlName="ddlDeliveryProduct" [items]="deliveryProductList" [clearable]="false"
                      bindLabel="name" [bindValue]="'id'" [appendTo]="'body'" [openOnEnter]="false" 
                      (keydown.enter)="useEnterKey && deliveryVendor.focus()"
                      (change)="getAWBCharges(category.VENDOR)">
                      <ng-template ng-option-tmp let-item="item" let-disabled="item.disabled">
                        <span>{{ item.name }}</span>
                    </ng-template>
                    </ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="deliveryVendor" class="form-label">Delivery Vendor</label>
                    <ng-select #deliveryVendor id="deliveryVendor" placeholder="Select" formControlName="ddlDeliveryVendor" [items]="deliveryVendorList" bindLabel="name"
                      [appendTo]="'body'" [openOnEnter]="false" [bindValue]="'id'" 
                      (keydown.enter)="useEnterKey && deliveryService.focus()"
                      (change)="getAllVendorServices('forwardinginfo')"></ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="deliveryService" class="form-label">Delivery Service</label>
                    <ng-select #deliveryService placeholder="Select" formControlName="ddlDeliveryService" [items]="deliveryServiceList"
                      bindLabel="servicename" [appendTo]="'body'" [openOnEnter]="false" [bindValue]="'id'" 
                      (keydown.enter)="useEnterKey && vendorWeight.focus()"
                      (change)="getAWBCharges(category.VENDOR)"></ng-select>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="vendorWeight" class="form-label">Vendor Weight</label>
                    <input #vendorWeight type="number" class="form-control form-control-sm" id="vendorweight" formControlName="txtVendorWeight" appLimitDigits [length]="8"
                      (keydown.enter)="useEnterKey && vendorInvoiceNo.focus()"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="vendorInvoiceNo" class="form-label">Vendor Invoice No.</label>
                    <input #vendorInvoiceNo type="text" class="form-control form-control-sm" id="vendorinvoice"
                      formControlName="txtVendorInvoiceNo" maxlength="30" 
                      (keydown.enter)="useEnterKey && appSharedVendorcharge.focusFirstField()"/>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <app-shared-charge #appSharedVendorcharge [chargeForm]="chargeForm" [forwardingInfo]="forwardingInfoTab" [(vendorRowData)]="vendorRowData"
                  (vendorDataList)="addData($event)" (forwardingChargeData)="addChargeData($event, 'Vendor')"
                  (chargesList)="getchargesList($event)" [(chargesOptions)]="chargeList" 
                  [(customerConfig)]="vendorConfig"
                  (focusEmit)="focusSubmitBtn()">
                </app-shared-charge>
              </div>
            </div>
          </ng-template>

        <ng-template [formGroup]="kycForm" #KYCContent>
          <div class="card-body">
            <div class="row">
              <div class="col-md-2">
                <div class="mb-2">
                  <label for="kycDocumentType" class="form-label">Document Type<span class="mandatory">*</span></label>
                  <ng-select id="kycDocumentType" #kycDocumentType [items]="kycDocumentOptions" bindLabel="name" [bindValue]="'name'"
                    [appendTo]="'body'" [openOnEnter]="false" 
                    (keydown.enter)="useEnterKey && kycForm.get('ddlDocumentType').valid ? kycdocumentno.focus() : kycForm.get('ddlDocumentType').markAsTouched()" formControlName="ddlDocumentType" placeholder="Select" 
                    (change)="documentTypeValidation('kycdoc', true); resetKycDocumentform()">
                  </ng-select>
                  <div
                      *ngIf="(iskycFormSubmitted || kycForm.get('ddlDocumentType').touched) && kycForm.get('ddlDocumentType').errors"
                      class="invalid-feedback">
                      <span *ngIf="kycForm.get('ddlDocumentType').errors?.required">Document Type is required</span>
                    </div>
                </div>
              </div>

              <div class="col-md-2">
                <div class="mb-2">
                  <label for="kycdocumentno" class="form-label">Document No.</label>
                  <input type="text" class="form-control form-control-sm" id="kycdocumentno" #kycdocumentno formControlName="txtDocumentNo" (change)="validateGSTINStateSelection($event.target.value, 'kyc')"
                    (keydown.enter)="useEnterKey && kycForm.get('txtDocumentNo').valid ? kycDocumentFile.focus() : kycForm.get('txtDocumentNo').markAsTouched()" [maxlength]="docCharacterLimit"
                    [ngClass]="{'is-invalid': (iskycFormSubmitted || kycForm.get('txtDocumentNo').touched) && kycForm.get('txtDocumentNo').errors}">
                  <div *ngIf="(iskycFormSubmitted || kycForm.get('txtDocumentNo')?.touched) && kycForm.get('txtDocumentNo').errors"
                    class="invalid-feedback">
                    <!-- <span *ngIf="kycForm.get('txtDocumentNo').errors.required">Document No. is required.</span> -->
                    <span *ngIf="kycForm.get('txtDocumentNo').errors.pattern">{{kycDocValidationMsg}}</span>
                  </div>
                </div>
              </div>

                <div class="col-md-4">
                  <div class="mb-2">
                    <div>
                      <small for="kycfile"><i class="mdi mdi-information">Note: Only .png, .jpeg, .jpg, .svg and .pdf image under 1 MB are allowed.</i></small>
                    </div>
                    <div class="input-group mb-2">
                      <input #kycDocumentFile id="choosefile" type="file" class="form-control form-control-sm" formControlName="txtDocument"
                        (keydown.enter)="useEnterKey && kycForm.get('txtDocument').valid ? kycUploadBtn.focus() : kycForm.get('txtDocument').markAsTouched()" (change)="onChangeFileSelect($event, 'AWBKyc')" accept=".png, .jpeg, .jpg, .svg, .pdf"
                        [ngClass]="{'is-invalid': (iskycFormSubmitted || kycForm.get('txtDocument').touched) && kycForm.get('txtDocument').errors}"/>
                        <div *ngIf="(iskycFormSubmitted || kycForm.get('txtDocument')?.touched) && kycForm.get('txtDocument').errors" class="invalid-feedback">
                          <span *ngIf="kycForm.get('txtDocument').errors.required">Document No. is required.</span>
                        </div>
                      <button #kycUploadBtn type="button" class="btn btn-primary btn-sm d-flex" (click)="uploadKycInfo('AWB')"(keydown.enter)="useEnterKey && uploadKycInfo('AWB')">
                        <i class="bx bx-upload font-size-15 me-1"></i>
                        Upload
                      </button>
                    </div>
                    <ng-container *ngIf="showProgressBar">
                      <div class="progress mt-2">
                        <div class="progress-bar progress-bar-striped" role="progressbar" [style.width.%]="progress"
                          [attr.aria-valuenow]="progress" aria-valuemin=" 0" aria-valuemin="100">
                          {{progress}}%
                        </div>
                      </div>
                    </ng-container>
                    <ng-container *ngIf="kycUploadedFileURL">
                      <a target="_blank" [href]="kycUploadedFileURL">{{kycUploadedFileName}}</a>
                  </ng-container>
                  </div>
                </div>

                <div class="col-md-4" style="margin-top: 20px;">
                  <div class="mb-2 ">
                    <button #kycSaveBtn type="button" class="btn btn-primary btn-sm" (click)="addKYC()">Save</button>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-4 mt-1">
                  <div class="table-responsive">
                    <table class="table table-sm m-0">
                      <thead class="table-light">
                        <tr>
                          <th style="width: 130px;">Type</th>
                          <th>Document No.</th>
                          <th style="width: 80px;">Action</th>
                        </tr>
                      </thead>
                      <tbody style="max-height: 60px;">
                        <tr *ngFor="let k of kycList; let i=index">
                          <td style="width: 130px;">{{k.type}}</td>
                          <td>{{k.no}}</td>
                          <td style="width: 80px;">
                            <a *ngIf="k.fileid" target="_blank" [href]="k.filepath"><i class="bx bx-show font-size-16 align-middle me-2"></i></a>
                            <i class="bx bx-trash font-size-16 align-middle me-2" (click)="deleteKycItem('AWB', i)"></i>
                          </td>
                        </tr>
                        <tr *ngIf="kycList?.length === 0">
                          <td colspan="6" class="text-center">
                            No records
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>

          <ng-template [formGroup]="receiptForm" #ReceiptsContent>
            <div class="card">
              <div class="card-body">
                <div class="row">
                  <div class="col-md-2">
                    <div class="mb-2">
                      <label for="paymentMode" class="form-label">Payment Mode<span class="mandatory">*</span></label>
                      <ng-select id="paymentMode" #paymentMode placeholder="Select" 
                        (keydown.enter)="useEnterKey && receiptForm.get('ddlPaymentMode').valid ? amountReceived.focus() : receiptForm.get('ddlPaymentMode').markAsTouched()" formControlName="ddlPaymentMode"
                        [items]="paymentOptions" bindLabel="name" [appendTo]="'body'" [openOnEnter]="false" [bindValue]="'id'"
                        [ngClass]="{'is-invalid':(isReceiptFormSubmitted || receiptForm.get('ddlPaymentMode').touched) && receiptForm.get('ddlPaymentMode').errors}"></ng-select>
                      <div
                        *ngIf="(isReceiptFormSubmitted || receiptForm.get('ddlPaymentMode').touched) && receiptForm.get('ddlPaymentMode').errors"
                        class="invalid-feedback">
                        <span *ngIf="receiptForm.get('ddlPaymentMode').errors.required">Payment Mode is required</span>
                      </div>
                    </div>
                  </div>

                <div class="col-md-2">
                  <div class="mb-2">
                    <label for="amountReceived" class="form-label">Amount Received<span class="mandatory">*</span></label>
                    <input type="number" class="form-control form-control-sm" id="amountReceived" #amountReceived
                      (keyup)="onEnterAmount($event)" formControlName="txtAmountReceived" 
                      (keydown.enter)="useEnterKey && receiptForm.get('txtAmountReceived').valid ? cashreceiptnumber.focus() : receiptForm.get('txtAmountReceived').markAsTouched()" appLimitDigits [length] = "15"
                      [ngClass]="{ 'is-invalid':(isReceiptFormSubmitted || receiptForm.get('txtAmountReceived').touched) && receiptForm.get('txtAmountReceived').errors}" />
                    <div *ngIf="(isReceiptFormSubmitted ||receiptForm.get('txtAmountReceived').touched) && receiptForm.get('txtAmountReceived').errors "
                      class="invalid-feedback">
                      <span *ngIf="receiptForm.get('txtAmountReceived').errors.pattern">Please enter a number with up to 10 digits and at most two decimal places.</span>
                      <span *ngIf="receiptForm.get('txtAmountReceived').errors.required">Amount Received is required</span>
                    </div>
                  </div>
                </div>

                  <div class="col-md-2">
                    <div class="mb-2">
                      <label for="balanceamount" class="form-label">Balance Amount</label>
                      <input type="number" class="form-control form-control-sm" id="balanceamount" #balanceamount (keyup)="onEnterAmount($event)"
                        formControlName="txtBalanceAmount" 
                        (keydown.enter)="useEnterKey && receiptForm.get('txtBalanceAmount').valid ? cashreceiptnumber.focus() : receiptForm.get('txtBalanceAmount').markAsTouched()"
                        [ngClass]="{'is-invalid':(isReceiptFormSubmitted || receiptForm.get('txtBalanceAmount') .touched) && receiptForm.get('txtBalanceAmount').errors}" />
                      <div
                        *ngIf="(isReceiptFormSubmitted || receiptForm.get('txtBalanceAmount').touched) && receiptForm.get('txtBalanceAmount').errors"
                        class="invalid-feedback">
                        <span *ngIf="receiptForm.get('txtBalanceAmount').errors.pattern">Please enter a number with up
                          to 10 digits and at most two decimal places.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="mb-2">
                      <label for="cashreceiptnumber" class="form-label">Cash Receipt No.</label>
                      <input type="number" class="form-control form-control-sm" id="cashreceiptnumber" #cashreceiptnumber
                        (keydown.enter)="useEnterKey && receiptForm.get('txtCashReceiptNo').valid ? cashreceiptdate.focus() : receiptForm.get('txtCashReceiptNo').markAsTouched()"
                        formControlName="txtCashReceiptNo"
                        [ngClass]="{'is-invalid':(isReceiptFormSubmitted ||receiptForm.get('txtCashReceiptNo').touched) && receiptForm.get('txtCashReceiptNo').errors}" />
                      <div
                        *ngIf="(isReceiptFormSubmitted ||receiptForm.get('txtCashReceiptNo').touched) && receiptForm.get('txtCashReceiptNo').errors "
                        class="invalid-feedback">
                        <span *ngIf="receiptForm.get('txtCashReceiptNo').errors.pattern">Please enter a number with up to 40 digits.</span>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-2">
                    <div class="mb-2">
                      <label for="cashreceiptdate" class="form-label">Cash Receipt Date<span class="mandatory">*</span></label>
                      <input type="datetime-local" class="form-control form-control-sm" id="cashreceiptdate" #cashreceiptdate
                      (keydown.enter)="useEnterKey && receiptForm.get('txtCashReceiptDate').valid ? receiptSaveBtn.focus() : receiptForm.get('txtCashReceiptDate').markAsTouched()"
                      [min]="awbForm.get('txtDateTime').value" max="3000-12-31T23:59" formControlName="txtCashReceiptDate" />
                    </div>
                    <div
                        *ngIf="(isReceiptFormSubmitted || receiptForm.get('txtCashReceiptDate').touched) && receiptForm.get('txtCashReceiptDate').errors"
                        class="invalid-feedback">
                        <span *ngIf="receiptForm.get('txtCashReceiptDate').errors.required">Date is required</span>
                      </div>
                  </div>

                  <div class="col-md-2 mt-4">
                    <div class="mb-2">
                      <button #receiptSaveBtn type="button" class="btn btn-primary btn-sm" (click)="upsertReceipt(!isReceiptEdit)">
                        {{ isReceiptEdit ? 'Update' : 'Save' }}
                      </button>
                      <button *ngIf="isReceiptEdit" type="button" class="btn btn-secondary btn-sm" (click)="resetReceiptForm()">Cancel</button>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 col-xl-6 mt-1">
                    <div class="table-responsive">
                      <table class="table table-sm m-0">
                        <thead class="table-light">
                          <tr>
                            <th style="width: 130px;">Payment Mode</th>
                            <th>Amount Received</th>
                            <!-- <th>Balance Amount</th> -->
                            <th>Cash Receipt No</th>
                            <th>Cash Receipt Date</th>
                            <th style="width: 80px;">Action</th>
                          </tr>
                        </thead>
                        <tbody style="max-height: 60px;">
                          <tr *ngFor="let r of receiptList; let i=index">
                            <td style="width: 130px;">{{r.paymentmodetype}}</td>
                            <td>{{r.amountreceived}}</td>
                            <!-- <td>{{r.balanceamount}}</td> -->
                            <td>{{r.cashreceiptno}}</td>
                            <td>{{utilities.FormatDateWithTime(0, r.cashreceiptdate).dateTimeStringAMPM}}</td>
                            <td style="width: 80px;">
                              <i class="bx bx-pencil font-size-16 align-middle me-2" (click)="editReceipt(i)"></i>
                              <i class="bx bx-trash font-size-16 align-middle me-2" (click)="deleteReceipt(i)"></i>
                            </td>
                          </tr>
                          <tr *ngIf="receiptList.length === 0">
                            <td colspan="6" class="text-center">
                              No records
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-12 mb-4">
        <div class="button-items">
          <button #submitBtn type="button" class="btn btn-primary" *ngIf="permConfig.isEditAllowed" (click)="updateAwb()" (keydown.enter)="$event.preventDefault();updateAwb()">Update</button>
          <a routerLink="/operation/awb"><button type="button" class="btn btn-secondary" (click)="hide()">Cancel</button></a>
        </div>
      </div>
    </div>
    
</form>
</ng-container>

<ng-template #historyModal let-modal>
    <div class="history-modal">
        <div class="modal-header">
            <h4 class="modal-title">History</h4>
            <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
        </div>
        <div class="modal-body">
            <label class="spaced-label"> Status: </label> <strong class="mx-2">{{ historyModalData.currentStatus}} </strong><br>
            <label class="spaced-label"> Last Updated At: </label> <strong class="mx-2">{{ historyModalData.lastUpdatedAt}} </strong><br>
            <label class="spaced-label"> Last Updated By: </label> <strong class="mx-2">{{ historyModalData.lastUpdatedBy}} </strong><br>
            <label class="spaced-label"> Invoice No: </label> <strong class="mx-2">{{ historyModalData.invoiceNo }} </strong><br>
            <label class="spaced-label"> Debit Note No: </label> <strong class="mx-2">{{ historyModalData.debitNoteFullNo }}</strong><br>
            <label class="spaced-label"> Credit Note No: </label> <strong class="mx-2">{{ historyModalData.creditNoteFullNo}}</strong>
        </div>
    </div>
</ng-template>

<ng-container *ngIf="!permConfig.isEditAllowed">
    <app-forbidden></app-forbidden>
</ng-container>